module.exports = __webpack_public_path__ + "static/img/brand-3.4a3a6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-3.png
// module id = bQ0c
// module chunks = 0